import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    COM_CATALOG_LIST, COM_CATALOG_ADD, COM_CATALOG_UPDATE,
    COM_CATALOG_DETAIL_LIST, COM_CATALOG_DETAIL_ADD, COM_CATALOG_DETAIL_UPDATE,
} from '../../actions';

import {
    ComCatalogListSuccess, ComCatalogListError,
    ComCatalogAddSuccess, ComCatalogAddError,
    ComCatalogUpdateSuccess, ComCatalogUpdateError,
    ComCatalogDetailListSuccess, ComCatalogDetailListError,
    ComCatalogDetailAddSuccess, ComCatalogDetailAddError,
    ComCatalogDetailUpdateSuccess, ComCatalogDetailUpdateError,
} from '../../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
        }, reject);
    });
}

// Catalog List
const onCatalogListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/catalog/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

// Catalog Add
const onCatalogAddAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/catalog/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

// Catalog Update
const onCatalogUpdateAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/catalog/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

// Catalog Detail List
const onCatalogDetailListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/catalog_detail/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

// Catalog Detail Add
const onCatalogDetailAddAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/catalog_detail/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

// Catalog Detail Update
const onCatalogDetailUpdateAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/catalog_detail/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

function* onCatalogList(data) {
    try {
        const response = yield call(onCatalogListAsync, data.payload);
        yield put(ComCatalogListSuccess(response.data));
    } catch (error) {
        yield put(ComCatalogListError(error));
    }
}

function* onCatalogAdd(data) {
    try {
        const response = yield call(onCatalogAddAsync, data.payload);
        if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        else NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        yield put(ComCatalogAddSuccess(response.data));
    } catch (error) {
        yield put(ComCatalogAddError(error));
    }
}

function* onCatalogUpdate(data) {
    try {
        const response = yield call(onCatalogUpdateAsync, data.payload);
        if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        else NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        yield put(ComCatalogUpdateSuccess(response.data));
    } catch (error) {
        yield put(ComCatalogUpdateError(error));
    }
}

function* onCatalogDetailList(data) {
    try {
        const response = yield call(onCatalogDetailListAsync, data.payload);
        yield put(ComCatalogDetailListSuccess(response.data));
    } catch (error) {
        yield put(ComCatalogDetailListError(error));
    }
}

function* onCatalogDetailAdd(data) {
    try {
        const response = yield call(onCatalogDetailAddAsync, data.payload);
        if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        else NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        yield put(ComCatalogDetailAddSuccess(response.data));
    } catch (error) {
        yield put(ComCatalogDetailAddError(error));
    }
}

function* onCatalogDetailUpdate(data) {
    try {
        const response = yield call(onCatalogDetailUpdateAsync, data.payload);
        if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        else NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        yield put(ComCatalogDetailUpdateSuccess(response.data));
    } catch (error) {
        yield put(ComCatalogDetailUpdateError(error));
    }
}

export function* watchCatalogList() { yield takeEvery(COM_CATALOG_LIST, onCatalogList); }
export function* watchCatalogAdd() { yield takeEvery(COM_CATALOG_ADD, onCatalogAdd); }
export function* watchCatalogUpdate() { yield takeEvery(COM_CATALOG_UPDATE, onCatalogUpdate); }
export function* watchCatalogDetailList() { yield takeEvery(COM_CATALOG_DETAIL_LIST, onCatalogDetailList); }
export function* watchCatalogDetailAdd() { yield takeEvery(COM_CATALOG_DETAIL_ADD, onCatalogDetailAdd); }
export function* watchCatalogDetailUpdate() { yield takeEvery(COM_CATALOG_DETAIL_UPDATE, onCatalogDetailUpdate); }

export default function* rootSaga() {
    yield all([
        fork(watchCatalogList),
        fork(watchCatalogAdd),
        fork(watchCatalogUpdate),
        fork(watchCatalogDetailList),
        fork(watchCatalogDetailAdd),
        fork(watchCatalogDetailUpdate),
    ]);
}
